module.exports = __webpack_public_path__ + "static/media/trainingPottyIcon.2d4f9186.png";